import { render, staticRenderFns } from "./ThrowingStar.vue?vue&type=template&id=73fd44dd&"
import script from "./ThrowingStar.vue?vue&type=script&lang=js&"
export * from "./ThrowingStar.vue?vue&type=script&lang=js&"
import style0 from "./ThrowingStar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports